import { render } from "./DataUpdate.vue?vue&type=template&id=47b8a6c8&scoped=true"
import script from "./DataUpdate.vue?vue&type=script&lang=js"
export * from "./DataUpdate.vue?vue&type=script&lang=js"

import "./DataUpdate.vue?vue&type=style&index=0&id=47b8a6c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b8a6c8"]])

export default __exports__